import React from 'react';
import { useTranslation } from 'react-i18next';
import { s } from '../helpers';

export interface UnclassifiedAlertProps {
  unclassifiedCount: number;
  openClassify: () => void;
}

export const UnclassifiedAlert: React.FC<UnclassifiedAlertProps> = ({
  unclassifiedCount,
  openClassify
}) => {
  const { t } = useTranslation();

  if (unclassifiedCount <= 0) return null;

  return (
    <div
      style={s(
        `display:flex;flex-wrap:wrap;align-items:center;gap:12px;padding:12px 16px;background:#FFF7EA;border:1px solid #F5D9A8;border-radius:12px`
      )}
    >
      <div
        style={s(
          `width:32px;height:32px;border-radius:8px;background:#FDEBCB;color:#C27C12;display:flex;align-items:center;justify-content:center;font-size:17px;flex:none`
        )}
      >
        <i className="icon-triangle-alert"></i>
      </div>
      <div style={s(`flex:1;min-width:220px;display:flex;flex-direction:column;gap:2px`)}>
        <span style={s(`font-size:14px;font-weight:600;color:#0F1B2D`)}>
          {t('managerNetwork.unclassified.title', '{{count}} accounts require classification', { count: unclassifiedCount })}
        </span>
        <span style={s(`font-size:12.5px;color:#6B7280;text-wrap:pretty`)}>
          {t('managerNetwork.unclassified.desc', 'Connected via bot/API but lifecycle stage is unknown. They are excluded from lifecycle and network metrics until an admin sets a stage.')}
        </span>
      </div>
      <button
        onClick={openClassify}
        style={s(
          `height:36px;padding:0 14px;border:1px solid #E0A445;border-radius:8px;background:#fff;color:#A8660B;font-size:13.5px;font-weight:600;cursor:pointer;display:flex;align-items:center;gap:6px`
        )}
      >
        {t('managerNetwork.unclassified.action', 'Review Accounts')}
        <i className="icon-arrow-right"></i>
      </button>
    </div>
  );
};
